import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App.jsx";
import store from "./store/store.js";
import "./main.scss";

const { VITE_SENTRY_FRONTEND_SERVER_DSN, VITE_NODE_ENV } = import.meta.env;

Sentry.init({
  dsn: VITE_SENTRY_FRONTEND_SERVER_DSN,
  sendDefaultPii: true,
  environment: VITE_NODE_ENV || "development",
});

const cspNonce = document
  .querySelector('meta[name="csp-nonce"]')
  .getAttribute("content");

const emotionCache = createCache({
  key: "css",
  nonce: cspNonce,
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <CacheProvider value={emotionCache}>
      <BrowserRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </BrowserRouter>
    </CacheProvider>
  </StrictMode>,
);
